import routes from './../routes'

export const sendComplaint = (data) => {
  return fetch(routes.zoho.complaint, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      "Accept": "application/json"
    }
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error("Error attempting to send complaints to Zoho");
  });
};

export const sendFileUpload = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return fetch(routes.zoho.fileUpload, {
    method: 'POST',
    body: formData,
    headers: {
      "Accept": "application/json"
    }
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error("Error attempting to upload file to Zoho");
  });
};
